FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    //  element
    var ELEM = '[data-fd="textarea"]';
    var eventsWired = false;

    $.widget("custom.textarea", {
        options: {
            useparent: true,
            parentid: -1,
            callbackprefix: 1,
            tag: 92,
            value: '',
            noedit: false,
            initial: '',
            autosizeonload: true,
            autosize: true,
            clearonload: false,
            repeat: false, //  repeat input
            submitevent: 'blur', //Other options include: enter, tab, blur
            disableresize: true //Disable Resizing the textarea
        },
        _create: function () {
            $.extend(this.options, this.element.data());

            if (!eventsWired) {
                $(document)
                    .on('focus', ELEM, this._handleFocus)
                    .on('blur', ELEM, this._handleBlur)
                    .on('keydown input', ELEM, this._handleKeyDown)
                    .on('keyup', ELEM, this._handleKeyUp);
                eventsWired = true;
            }

            me.setControlItemOptions(this.element, this.options);

            if (this.options.clearonload) {
                this.options.clearonload = false;
                this.element.val("").data("clearonload", false).attr("data-clearonload", false);
            }

            if (this.options.noedit) {
                this.element.attr('readonly', true);
            }

            if (this.options.autosize) {
                this.element.css({
                    'min-height': '16px',
                    resize: 'none'
                });
            }

            if (this.options.autosize && this.options.autosizeonload) {
                fastdom.measure(() => {
                    var scrollHeight = this.element.prop('scrollHeight');
                    if (scrollHeight > 0) {
                        fastdom.mutate(() => {
                            this.element.css('height', scrollHeight + 2);
                        });
                    }
                });
            }

            if (this.options.disableresize) {
                this.element.css('resize', 'none');
            } else {
                this.element.css('resize', 'both');
            }

            this.element.addClass("textarea");
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.element.data(options);
            this.refresh();
        },
        refresh: function () {
            this.element.attr({
                'data-tag': this.options.tag,
                'data-noedit': this.options.noedit
            });
            this.element.attr('disabled', this.options.noedit);
        },
        attach: function (self) {
            this.element = self;
        },
        _destroy: function () {
        },

        _handleFocus: function (event) {
            var self = $(event.target).closest(ELEM).data('customTextarea');
            self._hitEnter = false;

            if (self.options.repeat) {
                self.element.css('height', 'auto');
            }
            if (document.isUndo) {
                document.isUndo = false;
                return;
            }

            if (self.options.noedit || self.options.submitevent.indexOf('enter') > -1) {
                return;
            }

            self.options.initial = self.element.val();
        },
        _handleBlur: function (event) {
            var self = $(event.target).closest(ELEM).data('customTextarea');

            if (self.options.noedit) {
                return;
            }

            if (self.options.submitevent.indexOf('enter') > -1 && !self._hitEnter) {
                return;
            }

            self.options.value = self.element.val().trim();

            self._setCallback(event);
        },
        _handleKeyDown: function (event) {
            var self = $(event.target).closest(ELEM).data('customTextarea');

            if (self.options.autosize) {
                var offset = self.element.prop('offsetHeight') - self.element.prop('clientHeight');
                self.element.css('height', 'auto')
                    .css('height', self.element.prop('scrollHeight') + offset);
            }

            if ((event.which === 13 || event.keyCode === 13) && !event.shiftKey) {
                if (self.options.submitevent.indexOf('enter') > -1) {
                    event.preventDefault();
                    self._hitEnter = true;
                    self.element.blur();

                    //  repeat 
                    if (self.options.repeat) {
                        self.element.focus();
                    }
                }
            }
        },
        _handleKeyUp: function (event) {
            var self = $(event.target).closest(ELEM).data('customTextarea');

            if (event.which === 27 || event.keyCode === 27) { // Escape Key
                self.element.val(self.options.initial);
                me.setInputFocus(self.element, false);
                self._handleKeyDown(event);
            }
        },

        _setCallback: function () {
            if (this.options.value === this.options.initial) {
                return;
            }

            me.setCallBackFromData(this.element, {
                e: this.element,
                value: this.options.value,
                tag: this.options.tag,
                parentid: this.options.parentid
            });

            if (this.options.repeat) {
                this.options.value = '';
                this.element.val('');
            }

            this.options.initial = this.options.value;
            this.element.data('initial', this.options.value);
        }
    });


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set button
    child.setTextArea = function (wireEvent, container) {
        var list = '';
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        $(list).textarea();
    }


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));